// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__KsDQJ","content":"Layout_content__-XVhO","footer":"Layout_footer__1I3yD"};